export function toSlug(string) {
	string = string.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ");
	string = string.toLowerCase();
	string = string.replace(/^\s+|\s+$/gm, "");
	string = string.replace(/\s+/g, "-");
	return string;
}
